import { createAction, props } from '@ngrx/store';
import { Form } from '../../../domain/form.interface';

export const loadTemplatesList = createAction(
  '[TEMPLATE] Load Templates List',
  props<{ formId: string }>()
);

export const loadTemplatesListSuccess = createAction(
  '[TEMPLATE] Load Templates List Success',
  props<{ data: any }>()
);

export const loadTemplatesListFailure = createAction(
  '[TEMPLATE] Load Templates List Failure',
  props<{ error: any }>()
);

export const getSelectedTemplate = createAction(
  '[TEMPLATE] Get Selected Template',
  props<{ formId: string, template: Form }>()
);

export const getSelectedTemplateSuccess = createAction(
  '[TEMPLATE] Get Selected Template Success',
  props<{ template: Form }>()
);

export const getSelectedTemplateFailure = createAction(
  '[TEMPLATE] Get Selected Template Failure',
  props<{ error: string }>()
);

export const deleteTemplate = createAction(
  '[TEMPLATE] Delete Template',
  props<{ formId: string, template: Form }>()
);

export const deleteTemplateSuccess = createAction(
  '[TEMPLATE] Delete Template Success',
  props<{ pk: string; sk: string }>()
);

export const deleteTemplateFailure = createAction(
  '[TEMPLATE] Delete Templates Failure',
  props<{ error: any }>()
);

export const addTemplate = createAction(
  '[TEMPLATE] Add Template',
  props<{ formId: string }>()
);

export const addTemplateSuccess = createAction(
  '[TEMPLATE] Add Templates Success',
  props<{ template: Form }>()
);

export const addTemplateFailure = createAction(
  '[TEMPLATE] Add Template Failure',
  props<{ error: any }>()
);

export const editTemplate = createAction(
  '[TEMPLATE] Edit Template',
  props<{ formId: string, template: Form }>()
);

export const editTemplateSuccess = createAction(
  '[TEMPLATE] Edit Templates Success',
  props<{ template: Form }>()
);
export const editTemplateFailure = createAction(
  '[TEMPLATE] Edit Templates Failure',
  props<{ error: any }>()
);